export const TEXTS = {
  ADDRESSES_EMPTY_ERROR: 'Выберите хотя бы один адрес',
  CANCEL: 'Отменить',
  DATE_RANGE_ERROR: 'Период выгрузки отчёта — до 93 дней в пределах последних 3 лет',
  EXTERNAL_RECIPIENTS_INVALID_ERROR: 'Проверьте email внешних получателей',
  EXTERNAL_RECIPIENTS_MAX_COUNT_ERROR: 'Можно добавить не более 10 внешних получателей',
  MODAL_DESCRIPTION:
    'Отчёт будет сформирован и отправлен на электронную почту, а также будет доступен в разделе «Отчеты». Период выгрузки отчёта — до 93 дней в пределах последних 3 лет',
  MODAL_TITLE: 'Отчет по аудиорекламе',
  PERIOD_LABEL: 'Период',
  PROMO_EMPTY: 'Проморолики не найдены',
  PROMO_ERROR: 'Не удалось загрузить проморолики',
  PROMO_LABEL: 'Проморолик',
  PROMO_PLACEHOLDER: 'Выберите проморолик',
  PROMO_REQUIRED_ERROR: 'Выберите проморолик',
  PROMO_RETRY: 'Повторить',
  RECIPIENTS_EMPTY_ERROR: 'Выберите хотя бы одного получателя отчета',
  RECIPIENTS_MAX_COUNT_ERROR: 'Можно выбрать не более 150 получателей отчета',
  REQUEST: 'Запросить отчет',
  REQUEST_EXISTS_NOTIFICATION:
    'Отчет по дням по аудиорекламе за указанный период был сформирован ранее и отправлен на электронную почту. Пожалуйста, проверьте свою электронную почту',
  REQUEST_SUCCESS_NOTIFICATION:
    'Отчет по дням по аудиорекламе будет сформирован в течение нескольких минут и отправлен на электронную почту. Также отчет будет доступен в разделе «Отчеты»',
};
